import { z } from 'zod';

const textPartSchema = z.object({
  text: z.string().min(1, 'Le texte ne peut pas être vide'),
  highlight: z.boolean(),
});

export const promoBannerSchema = z.object({
  region: z.enum(['FR', 'US']),
  textParts: z
    .array(textPartSchema)
    .min(1, 'Au moins une partie de texte requise'),
  buttonText: z.string().trim().min(1, 'Champ requis'),
  buttonLink: z.string().trim().min(1, 'Champ requis'),
  file: z.instanceof(File),
});

export const updatePromoBannerSchema = promoBannerSchema.extend({
  file: z.instanceof(File).optional(),
});

export type PromoBannerSchemaType = z.infer<typeof promoBannerSchema>;
export type UpdatePromoBannerSchemaType = z.infer<
  typeof updatePromoBannerSchema
>;
